var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFilledWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9154 12.4997C22.9154 6.74671 18.2516 2.08301 12.4987 2.08301C6.74573 2.08301 2.08203 6.74671 2.08203 12.4997C2.08203 18.2526 6.74573 22.9163 12.4987 22.9163C18.2516 22.9163 22.9154 18.2526 22.9154 12.4997Z",
    fill: "white",
    stroke: "#0464B2",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 13.0208L10.9362 15.625L16.6654 9.375",
    stroke: "#0464B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFilledWhite);
export default __webpack_public_path__ + "static/media/checkFilledWhite.90c04a0ece29054b130b101a2eef6e1e.svg";
export { ForwardRef as ReactComponent };